<template>
  <div>
    <!-- Small Demo Card -->
    <div class="demo-card" aria-hidden>
      <div class="demo-content">
        <div class="demo-text">
          <h4>Schedule a Demo</h4>
        </div>
        <div class="demo-cta">
          <button class="schedule-btn" @click="dialogVisible = true">Schedule</button>
        </div>
      </div>
    </div>

    <Modal
      title="Schedule a Demo"
      :show.sync="dialogVisible"
      :closeOnBackdrop="!this.isSubmitting"
      :showClose="!this.isSubmitting"
      size="lg"
    >
      <!-- ✅ Custom Header Slot -->
      <template #header>
        <div class="d-flex justify-content-between align-items-center w-100">
          <h4 class="mb-0">Schedule a Demo</h4>
          <!-- ✅ Add a close button -->
<!--          <button-->
<!--            type="button"-->
<!--            class="btn-close"-->
<!--            @click="dialogVisible = false"-->
<!--            aria-label="Close"-->
<!--          ></button>-->
        </div>
      </template>

      <!-- ✅ Form Body -->
      <form class="general-form" @submit.prevent="submitForm">

        <div class="row">
          <div class="col-md-6">
            <label class="form-control-label fw-bold">
              First Name<span class="requireField"> *</span>
            </label>
            <base-input
              type="text"
              v-model="form.firstName"
              placeholder="Enter your first name"
            ></base-input>
          </div>

          <div class="col-md-6">
            <label class="form-control-label fw-bold">
              Last Name<span class="requireField"> *</span>
            </label>
            <base-input
              type="text"
              v-model="form.lastName"
              placeholder="Enter your last name"
            ></base-input>
          </div>

          <div class="col-md-6">
            <label class="form-control-label fw-bold">
              Email Address<span class="requireField"> *</span>
            </label>
            <base-input
              type="email"
              v-model="form.email"
              placeholder="Enter your email address"
            ></base-input>
          </div>

          <div class="col-md-6">
            <label class="form-control-label fw-bold">
              Phone Number<span class="requireField"> *</span>
            </label>
            <base-input
              type="text"
              v-model="form.phone"
              placeholder="Enter your phone number"
            ></base-input>
          </div>

          <div class="col-md-6">
            <label class="form-control-label fw-bold">
              Company Name<span class="requireField"> *</span>
            </label>
            <base-input
              type="text"
              v-model="form.company"
              placeholder="Enter your company name"
            ></base-input>
          </div>

          <div class="col-md-6 mt-1">
            <label class="form-control-label fw-bold d-block">
              Date and Time
            </label>
            <el-date-picker
              v-model="form.showDate"
              type="datetime"
              class="w-100"
              format="MM/dd/yyyy hh:mm:ss A"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="Please select"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </div>
        </div>

        <base-button
          native-type="submit"
          type="primary"
          class="mt-4 primary-orange border-0 w-100 rounded-3 fw-bold"
          :loading="isSubmitting"
          :disabled="isSubmitting"
          style="padding: 10px 20px;"
        >
          Submit
        </base-button>
      </form>
    </Modal>

  </div>
</template>

<script>

import Modal from "@/components/Modal";
import { DatePicker, Tooltip } from 'element-ui';
export default {
  name: "ScheduleDemo",

  data() {
    return {
      dialogVisible: false,
      isSubmitting: false,
      feedbackMessage: "",
      form: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        company: "",
        showDate: "",
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now(); // disable past dates
        },
      },
    };
  },
  components: {
    Modal,
    [DatePicker.name]: DatePicker,
    [Tooltip.name]: Tooltip,
  },
  methods: {
    openDialog() {
      this.dialogVisible = true;
    },

    handleClose() {
      this.dialogVisible = false;
      this.resetForm();
    },

    resetForm() {
      this.form = {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        company: "",
        showDate: "",
      };
      this.feedbackMessage = "";
    },

    async submitForm() {
      this.isSubmitting = true;
      this.feedbackMessage = "";

      const payload = {
        first_name: this.form.firstName,
        last_name: this.form.lastName,
        email: this.form.email,
        phone: this.form.phone,
        company: this.form.company,
        date_time: this.form.showDate,
      };

      try {
        const response = await this.$http.post("/user/sendDemoRequest", payload);
        this.feedbackMessage =
          "Your demo request has been submitted successfully!";
        this.$toast?.success(this.feedbackMessage, {timeout: 5000});
        this.resetForm();
        this.dialogVisible = false;
      } catch (error) {

          this.feedbackMessage =
            "There was an error submitting your request. Please try again.";
        this.$toast?.error?.(this.feedbackMessage, {timeout: 5000});
        console.error(error);
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.live-chat,
.demo-card {
  border-radius: 15px;
  background: #fff;
  border: 1px solid rgba(235, 26, 38, 0.2);
}
.demo-card {
  background: rgba(232, 83, 47, 0.03);
  color: rgba(255, 255, 255, 0.9);
  padding: 22px 20px;
  border-radius: 12px;
  display: flex;
  align-items: center;

.demo-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.demo-text h4 {
  margin: 0;
  font-size: 16px;
  line-height: 18px;
  font-weight: 700;
  color: rgba(234, 37, 39, 1);
}

.demo-cta .schedule-btn {
  background: transparent;
  border: 1px solid rgba(234, 37, 39, 1);
  color: rgba(234, 37, 39, 1);
  padding: 8px 12px;
  border-radius: 10px;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
}
}
@media (min-width: 1024px) {
  .demo-card {
    background: rgba(232, 83, 47, 0.03);
    color: rgba(255, 255, 255, 0.9);
    padding: 22px 20px;
    border-radius: 12px;
    display: flex;
    align-items: center;

    .demo-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
    }

    .demo-text h4 {
      margin: 0;
      font-size: 16px;
      line-height: 18px;
      font-weight: 700;
      color: rgba(234, 37, 39, 1);
    }

    .demo-cta .schedule-btn {
      background: transparent;
      border: 1px solid rgba(234, 37, 39, 1);
      color: rgba(234, 37, 39, 1);
      padding: 8px 12px;
      border-radius: 10px;
      font-weight: 500;
      font-size: 12px;
      line-height: 15px;
    }
  }
}
</style>
